import { TABLE_DIMENSIONS } from '../utils';

export const PAGE_SIZE = 10;

export const getColumnDefs = (spendFormatter, sortModel, tableDimension) => {
	const showGL = tableDimension === TABLE_DIMENSIONS[0].value;

	return [
		{
			headerName: showGL ? 'GL code' : 'Cost centre',
			field: 'name',
			colId: 'name',
			minWidth: 120,
			width: 120,
			maxWidth: 120,
			...(sortModel && sortModel.colId === 'name'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: `${showGL ? 'GL' : 'Cost centre'} description`,
			field: 'description',
			colId: 'description',
			minWidth: 140,
			flex: 1,
			...(sortModel && sortModel.colId === 'description'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: 'YTD vs revised budget performance',
			field: '',
			sortable: false,
			minWidth: 148,
			width: 148,
			maxWidth: 148,
			cellRenderer: 'miniChartCellRenderer',
		},
		{
			headerName: 'YTD vs revised budget variance',
			colId: 'variance',
			field: 'variance',
			type: 'numericColumn',
			headerClass: 'ag-numeric-header',
			cellStyle: { textAlign: 'right' },
			minWidth: 144,
			width: 144,
			maxWidth: 144,
			...(sortModel && sortModel.colId === 'variance'
				? { sort: sortModel.sort }
				: {}),
			valueFormatter: params => spendFormatter(params.value),
		},
		{
			headerName: 'Budget target status',
			colId: 'status',
			field: 'status',
			minWidth: 168,
			width: 168,
			maxWidth: 168,
			...(sortModel && sortModel.colId === 'status'
				? { sort: sortModel.sort }
				: {}),
			cellRenderer: 'statusCellRenderer',
		},
		{
			headerName: '',
			colId: 'tooltip',
			minWidth: 40,
			width: 40,
			maxWidth: 40,
			cellRenderer: 'iconCellRenderer',
		},
	];
};
